<div [formGroup]="parentForm">
  <div class="form-group">
    <rx-input
      data-qa="test-password-input"
      data-dd-privacy="mask-user-input"
      formControlName="password"
      type="password"
      placeholder="••••••••••••"
      [label]="passwordLabel"
    >
      <div rx-error>
        <div data-qa="test-password-error-required" *ngIf="isFieldInvalid(parentForm, 'password', 'required')">
          {{ passwordMissing }}
        </div>
        <div data-qa="test-password-error-pattern" *ngIf="isFieldInvalid(parentForm, 'password', 'pattern')">{{ passwordPattern }}</div>
      </div>
    </rx-input>
  </div>
  <div class="form-group">
    <rx-input
      data-qa="test-reType-password-input"
      data-dd-privacy="mask-user-input"
      formControlName="reTypePassword"
      type="password"
      placeholder="••••••••••••"
      [label]="passwordConfirmLabel"
    >
      <div rx-error>
        <div data-qa="test-reType-password-error-required" *ngIf="isFieldInvalid(parentForm, 'reTypePassword', 'required')">
          {{ passwordMissing }}
        </div>
        <div data-qa="test-reType-password-error-equalTO" *ngIf="isFieldInvalid(parentForm, 'reTypePassword', 'equalTo')">
          {{ passwordNotEqual }}
        </div>
      </div>
    </rx-input>
  </div>
</div>
